import { c as _c } from "react/compiler-runtime";
import React from "react";
const PriceRangeSlider = t0 => {
  const $ = _c(74);
  const {
    min: t1,
    max: t2,
    step: t3,
    value,
    onChange
  } = t0;
  const min = t1 === undefined ? 0 : t1;
  const max = t2 === undefined ? 5000 : t2;
  const step = t3 === undefined ? 100 : t3;
  const validMin = Math.min(min, max);
  const validMax = Math.max(min, max);
  let t4;
  if ($[0] !== validMax || $[1] !== validMin || $[2] !== value) {
    t4 = value || [validMin, validMax];
    $[0] = validMax;
    $[1] = validMin;
    $[2] = value;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [minVal, maxVal] = t4;
  const safeMinVal = Math.max(validMin, Math.min(minVal, validMax));
  const safeMaxVal = Math.max(validMin, Math.min(maxVal, validMax));
  let t5;
  if ($[4] !== onChange || $[5] !== safeMaxVal || $[6] !== step) {
    t5 = e => {
      const val = Math.min(Number(e.target.value), safeMaxVal - step);
      onChange([val, safeMaxVal]);
    };
    $[4] = onChange;
    $[5] = safeMaxVal;
    $[6] = step;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleMinChange = t5;
  let t6;
  if ($[8] !== onChange || $[9] !== safeMinVal || $[10] !== step) {
    t6 = e_0 => {
      const val_0 = Math.max(Number(e_0.target.value), safeMinVal + step);
      onChange([safeMinVal, val_0]);
    };
    $[8] = onChange;
    $[9] = safeMinVal;
    $[10] = step;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleMaxChange = t6;
  let t7;
  if ($[12] !== validMax || $[13] !== validMin) {
    t7 = val_1 => {
      const range = validMax - validMin;
      if (range === 0) {
        return 0;
      }
      return Math.round((val_1 - validMin) / range * 100);
    };
    $[12] = validMax;
    $[13] = validMin;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const getPercent = t7;
  let t8;
  if ($[15] !== onChange || $[16] !== safeMaxVal || $[17] !== safeMinVal || $[18] !== step || $[19] !== validMax || $[20] !== validMin) {
    t8 = e_1 => {
      const rect = e_1.currentTarget.getBoundingClientRect();
      const clickX = e_1.clientX - rect.left;
      const clickPercent = clickX / rect.width * 100;
      const range_0 = validMax - validMin;
      const clickedValue = validMin + range_0 * clickPercent / 100;
      const roundedValue = Math.round(clickedValue / step) * step;
      const clampedValue = Math.max(validMin, Math.min(roundedValue, validMax));
      const minDistance = Math.abs(clampedValue - safeMinVal);
      const maxDistance = Math.abs(clampedValue - safeMaxVal);
      if (minDistance <= maxDistance) {
        const newMinVal = Math.min(clampedValue, safeMaxVal - step);
        onChange([newMinVal, safeMaxVal]);
      } else {
        const newMaxVal = Math.max(clampedValue, safeMinVal + step);
        onChange([safeMinVal, newMaxVal]);
      }
    };
    $[15] = onChange;
    $[16] = safeMaxVal;
    $[17] = safeMinVal;
    $[18] = step;
    $[19] = validMax;
    $[20] = validMin;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const handleTrackClick = t8;
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="font-bold text-[10px] uppercase text-stone-400 tracking-wider">Price Range</p>;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== safeMinVal) {
    t10 = safeMinVal.toLocaleString();
    $[23] = safeMinVal;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== safeMaxVal) {
    t11 = safeMaxVal.toLocaleString();
    $[25] = safeMaxVal;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <div className="flex justify-between items-center mb-6">{t9}<span className="text-[11px] font-extrabold text-[#037a6a] bg-[#037a6a]/10 px-3 py-1 rounded-full font-outfit">₹{t10} - ₹{t11}</span></div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      height: "4px"
    };
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== handleTrackClick) {
    t14 = <div className="absolute top-0 left-0 w-full h-full bg-stone-100 rounded-full cursor-pointer" onClick={handleTrackClick} />;
    $[31] = handleTrackClick;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== getPercent || $[34] !== safeMinVal) {
    t15 = getPercent(safeMinVal);
    $[33] = getPercent;
    $[34] = safeMinVal;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const t16 = `${t15}%`;
  let t17;
  if ($[36] !== getPercent || $[37] !== safeMaxVal) {
    t17 = getPercent(safeMaxVal);
    $[36] = getPercent;
    $[37] = safeMaxVal;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== getPercent || $[40] !== safeMinVal) {
    t18 = getPercent(safeMinVal);
    $[39] = getPercent;
    $[40] = safeMinVal;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = `${t17 - t18}%`;
  let t20;
  if ($[42] !== t16 || $[43] !== t19) {
    t20 = <div className="absolute top-0 h-full bg-[#037a6a] rounded-full pointer-events-none shadow-sm" style={{
      left: t16,
      width: t19
    }} />;
    $[42] = t16;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const t21 = safeMinVal > safeMaxVal - step * 2 ? 5 : 3;
  let t22;
  if ($[45] !== t21) {
    t22 = {
      zIndex: t21,
      top: "0px"
    };
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== handleMinChange || $[48] !== safeMinVal || $[49] !== step || $[50] !== t22 || $[51] !== validMax || $[52] !== validMin) {
    t23 = <input type="range" min={validMin} max={validMax} step={step} value={safeMinVal} onChange={handleMinChange} aria-label="Minimum price" className="absolute w-full h-1 bg-transparent appearance-none pointer-events-none price-slider-input" style={t22} />;
    $[47] = handleMinChange;
    $[48] = safeMinVal;
    $[49] = step;
    $[50] = t22;
    $[51] = validMax;
    $[52] = validMin;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  const t24 = safeMaxVal < safeMinVal + step * 2 ? 5 : 4;
  let t25;
  if ($[54] !== t24) {
    t25 = {
      zIndex: t24,
      top: "0px"
    };
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== handleMaxChange || $[57] !== safeMaxVal || $[58] !== step || $[59] !== t25 || $[60] !== validMax || $[61] !== validMin) {
    t26 = <input type="range" min={validMin} max={validMax} step={step} value={safeMaxVal} onChange={handleMaxChange} aria-label="Maximum price" className="absolute w-full h-1 bg-transparent appearance-none pointer-events-none price-slider-input" style={t25} />;
    $[56] = handleMaxChange;
    $[57] = safeMaxVal;
    $[58] = step;
    $[59] = t25;
    $[60] = validMax;
    $[61] = validMin;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== t14 || $[64] !== t20 || $[65] !== t23 || $[66] !== t26) {
    t27 = <div className="relative h-1" style={t13}>{t14}{t20}{t23}{t26}</div>;
    $[63] = t14;
    $[64] = t20;
    $[65] = t23;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="flex justify-between mt-4"><span className="text-[10px] font-bold text-stone-500 uppercase tracking-widest">Min</span><span className="text-[10px] font-bold text-stone-500 uppercase tracking-widest">Max</span></div>;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== t27) {
    t29 = <div className="px-2">{t27}{t28}</div>;
    $[69] = t27;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t12 || $[72] !== t29) {
    t30 = <div className="pb-4 mb-2 border-b border-stone-100">{t12}{t29}</div>;
    $[71] = t12;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  return t30;
};
export default PriceRangeSlider;